import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import formatPercentage from "../../unit/formatPercentage";
import useNotify from "../../unit/useNotify";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const LoanModificationReduceLog = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/modifyReducePayment",
    { id: appId }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;
  const modifyReduceData = data.modifyReduceData;

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable stickyHeader id="table-loan-summary-modification-log-list">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reset Date
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reset by
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                First Reduced Payment Date
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Reduced Payment Amount
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Number of Reduced Payments
              </TableCell>

              {/* <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Round up Payment
              </TableCell> */}

              <TableCell className="hm-table-header">
                New Remaining Term
              </TableCell>
              <TableCell className="hm-table-header">
                New Maturity Date
              </TableCell>
              <TableCell className="hm-table-header">Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modifyReduceData &&
              modifyReduceData.map((item: any) => (
                <TableRow key={item.iId}>
                  <TableCell className="dateText">
                    {formatDate(item.created_at)}
                  </TableCell>

                  <TableCell className="dateText">{item.created_by}</TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dFirstPaymentDate)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.iReducedPaymentAmount)}
                  </TableCell>
                  <TableCell className="numericText">
                    {item?.iNumberPaymentPeriods}
                  </TableCell>

                  {/* <TableCell>
                    {item.iPaymentRoundUp == 1 ? "YES" : "NO"}
                  </TableCell> */}
                  <TableCell className="numericText">
                    {item?.iRemainingTerms}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item?.dMaturityDate)}
                  </TableCell>
                  <TableCell>{item?.sNote}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanModificationReduceLog;
